module.exports = __webpack_public_path__ + "img/750-1.35ee2630.png";